<div class="payroll-container">
  <div class="employees-container">
    <div class="header">
      <button mat-button class="td-btn primary" (click)="addEmployee()">Agregar empleado</button>
      <button mat-button class="td-btn primary" *ngIf="employees?.length" (click)="sendPayments()">
        Realizar Pagos
      </button>
    </div>
    <p class="no-employees" *ngIf="!employees?.length">No se ha registrado ningún empleado</p>
    <div class="table-container" *ngIf="employees?.length">
      <div class="table">
        <div class="header">
          <span>CUIT</span>
          <span>Nombre / Apellido</span>
          <span>Salario</span>
        </div>
        <div class="employee" *ngFor="let employee of employees" (click)="editEmployee(employee)">
          <span>{{ employee.userId.cuit }}</span>
          <span>{{ employee.userId.name }}</span>
          <span
            >{{ employee.salary | formatCoinAmount: (employee.isArs ? 'AR$' : 'DAI') }}
            {{ employee.isArs ? 'AR$' : 'DAI' }}</span
          >
        </div>
      </div>
    </div>
  </div>
</div>
